import Locale from 'data/locale';
import { profileFix, profileIsEmpty } from 'logic/profileReducers';
import React from 'react';

import Store from 'store';
import EditingContext from 'store/editingContext';
import History, { useCanUndo } from 'store/history';
import { exportAllProfiles } from 'logic/import';
import { usePersistentState } from 'utils';
import { _R } from 'utils/format';

const _L = Locale();

function isEmptyState(state) {
  return state.profiles.length === 1 && profileIsEmpty(state.profiles[0]);
}

export default React.memo(function AutoSave() {
  const [backup, setBackup] = usePersistentState("stateBackup", null);
  const [changed, setChanged] = EditingContext.useState("profileChanged", false);

  const state = Store.useState();
  const isEmpty = isEmptyState(state);
  const canUndo = useCanUndo();

  const historyStore = History.useStore();

  const dispatch = Store.useDispatch();

  React.useEffect(() => {
    if (canUndo) {
      const handle = setTimeout(() => {
        const historyState = historyStore.getState();
        setBackup(exportAllProfiles(state, historyState));
      }, 1000);
      return () => clearTimeout(handle);
    }
  }, [setBackup, state, canUndo, historyStore]);

  React.useEffect(() => {
    if (!changed && !isEmpty) {
      setChanged(true);
    }
  }, [setChanged, changed, isEmpty]);

  const onRestore = React.useCallback(() => {
    if (backup && backup.profiles) {
      const state = {...backup};
      delete state.auto;
      state.profiles = backup.profiles.map(profile => profileFix(profile));
      dispatch.setState(state);
    }
  }, [dispatch, backup]);

  const onClear = React.useCallback(() => {
    setBackup(null);
  }, [setBackup]);

  React.useEffect(() => {
    if (backup && backup.auto) {
      onRestore();
      setBackup({...backup, auto: false});
    }
  }, [backup, onRestore, setBackup]);

  if (!backup || !backup.profiles || changed) {
    return null;
  }

  return (
    <div className="d3p-RestoreSession">
      {_L`Restore last session?`}{_R` ${<span onClick={onRestore}>{_L`Yes`}</span>} / ${<span onClick={onClear}>{_L`No`}</span>}`}
    </div>
  );
});
